import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
from { opacity: 0; }
    to   { opacity: 1; }
`;

export const CoursesListStyle = styled.div`
  padding: 2rem 1rem 4rem 1rem;
  max-width: 820px;
  margin: 0 auto;
  color: ${({ theme }) => theme.UI_COLORS.secondary};
`;

export const CoursesListHeadingStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem 0 1rem;
  flex-wrap: wrap;

  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    padding: 0 2rem 0 2rem;
  }

  & > div.redirect-input {
    display: flex;
    padding: 2rem 0;

    & > input {
      height: 20px;
      width: 20px;
      margin: 0;
    }

    & > label {
      margin-bottom: 0;
      padding-left: 5px;
    }
  }
`;

export const CoursesListHeadingsGroupStyle = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > h1 {
    cursor: pointer;
    font-size: 2.4rem;

    &:after {
      content: '';
      border: 1px solid ${({ theme }) => theme.UI_COLORS.secondary};
      margin: 0 1rem;
    }

    &:last-of-type:after {
      display: none;
    }

    @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
      font-size: 3.6rem;
    }
  }
`;

export const CoursesListItemStyle = styled.div`
  background-color: ${({ theme }) => theme.UI_COLORS.light};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  margin-bottom: 1rem;
  padding: 3rem 3rem 5rem 2rem;
  display: flex;
  transition: box-shadow 0.3s ease-out;
  animation: ${fadeIn} 0.5s;
  color: ${({ theme }) => theme.UI_COLORS.secondary};
  text-decoration: none;
  position: relative;

  &:hover {
    box-shadow: 0 15px 20px rgba(0, 0, 0, 0.35);
  }

  & > div.course-icon {
    display: none;

    @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
      display: block;
      max-width: 100px;

      & > img {
        width: 80px;
        height: auto;
        margin-right: 2rem;
      }
    }
  }

  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    margin-bottom: 2rem;
    &:last-of-type {
      margin-bottom: 0;
    }
  }

  & > div.course-description {
    width: 100%;

    & > div.semi-title {
      font-size: 1.2rem;
      color: #5f6d6d;
      font-weight: 400;
    }

    & > p {
      margin: 2rem 0;
      font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyText.fontSize};
      font-weight: ${({ theme }) => theme.TYPOGRAPHY.bodyText.fontWeight};
      line-height: 2.6rem;
    }

    & > div.title-section {
      display: flex;
      justify-content: space-between;
      align-items: center;

      & > h2 {
        margin-top: 0;
        margin-bottom: 1rem;
      }
    }
  }

  div.additional-info {
    display: flex;
    font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyText.fontSize};
    font-weight: ${({ theme }) => theme.TYPOGRAPHY.bodyText.fontWeight};
    margin-top: 3rem;

    & > div.additional-info-labels {
      color: ${({ theme }) => theme.UI_COLORS.medium_gray};
      margin-right: 3rem;
      & > div {
        margin-bottom: 1.7rem;
      }
    }

    & > div.additional-info-data > div {
      margin-bottom: 1.7rem;
      word-break: break-word;
    }
  }
`;

export const LastMaterialLink = styled.span`
  & > a {
    text-decoration: none;
    display: inline-block;
    transition: transform 0.3s ease-out;

    &:hover {
      transform: translateX(5px);
    }
  }
`;

export const SearchInput = styled.input`
  border: none;
  border-radius: 4px;
  background-color: #0b0c0c;
  height: 40px;
  display: none;
  color: ${({ theme }) => theme.UI_COLORS.light};
  padding-left: 2rem;
  padding-right: 5rem;
  width: 32vw;
  max-width: 580px;
  outline: none;
  animation: ${fadeIn} 0.5s;
  box-sizing: border-box;

  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    display: inline-block;
  }
`;

export const SearchInputMobile = styled.input`
  border: none;
  border-radius: 4px;
  background-color: #0b0c0c;
  height: 40px;
  color: ${({ theme }) => theme.UI_COLORS.light};
  padding-left: 2rem;
  padding-right: 5rem;
  width: 50vw;
  max-width: 580px;
  outline: none;
  animation: ${fadeIn} 0.5s;
`;

export const SearchInputIconMobile = styled.span`
  position: absolute;
  right: 10px;
  top: 10px;
`;

export const SearchInputIcon = styled.span`
  position: absolute;
  right: 10px;
  top: 10px;
  display: none;

  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    display: inline-block;
  }
`;

export const ClearInputIcon = styled.span`
  position: absolute;
  right: 50px;
  top: 6px;
  display: none;
  animation: ${fadeIn} 0.5s;

  &:after {
    content: '';
    border: 1px solid ${({ theme }) => theme.UI_COLORS.medium_gray};
    position: absolute;
    height: 24px;
    top: 3px;
    right: -7px;
  }

  &:hover {
    cursor: pointer;
  }

  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    display: inline-block;
  }
`;

export const GoBackButton = styled.button`
  animation: ${fadeIn} 0.5s;
  margin-left: 3rem;

  & > div > svg {
    fill: ${({ theme }) => theme.UI_COLORS.secondary};
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
`;

export const NoItemsStyle = styled.div`
  & > h1 {
    animation: ${fadeIn} 0.5s;
    font-size: 3rem;
    font-weight: bold;
  }
  & > p {
    font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyText.fontSize};
    font-weight: 500;

    & > a {
      color: ${({ theme }) => theme.UI_COLORS.primary};
    }
  }
`;

export const AdminSection = styled.div`
  & > a {
    color: ${({ theme }) => theme.UI_COLORS.secondary};
    text-decoration: none;
    display: flex;
    align-items: center;

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;
